import { Haptics, NotificationType } from "@capacitor/haptics";

/**
 * Plays a short 880Hz sine "ding" using Web Audio API.
 * Envelope: 0 → 0.3 gain over 10ms, sustain 200ms, fade to 0 over 40ms.
 * Total duration ~250ms. No bundled asset; works in WKWebView + Chrome
 * Custom Tabs + browsers.
 *
 * AudioContext is created fresh per call so the GC can reclaim it after
 * the oscillator stops.
 */
export function playTimerEndBeep(): void {
  try {
    const AudioCtor =
      (window as any).AudioContext || (window as any).webkitAudioContext;
    if (!AudioCtor) return;
    const ctx = new AudioCtor() as AudioContext;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = "sine";
    osc.frequency.value = 880;
    osc.connect(gain);
    gain.connect(ctx.destination);

    const now = ctx.currentTime;
    gain.gain.setValueAtTime(0, now);
    gain.gain.linearRampToValueAtTime(0.3, now + 0.01);   // attack 10ms
    gain.gain.setValueAtTime(0.3, now + 0.21);             // sustain 200ms
    gain.gain.linearRampToValueAtTime(0, now + 0.25);     // release 40ms

    osc.start(now);
    osc.stop(now + 0.26);
    osc.onended = () => {
      try { void ctx.close(); } catch { /* noop */ }
    };
  } catch (e) {
    console.error("[focus/feedback] beep failed", e);
  }
}

/**
 * Triggers a Success-style haptic notification. Best-effort: on web or
 * when the Haptics plugin is unavailable, silently logs and resolves.
 */
export async function triggerTimerEndHaptics(): Promise<void> {
  try {
    await Haptics.notification({ type: NotificationType.Success });
  } catch (e) {
    console.error("[focus/feedback] haptics unavailable", e);
  }
}
